/*  修改密码 */
import { FC } from 'react';
import { Modal, Form, message } from 'antd';
import FormInputPassword from '@/common/components/Form/FormInputPassword';

import { EIGHT_SIXTEEN_PASSWORD_REG } from '@lhb/regexp';
import { post } from '@/common/request';
import { dispatchNavigate } from '@/common/document-event/dispatch';
import { useMethods } from '@lhb/hook';
import { singleLogout } from '@lhb/cache';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
const pstRule = { pattern: EIGHT_SIXTEEN_PASSWORD_REG, message: '密码格式错误' };

const ModifyPassword: FC<{ visible, onClose }> = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const methods = useMethods({
    onOk() {
      form.validateFields().then((values: any) => {
        post('/resetPassword', values, {
          needHint: true,
        }).then(() => {
          message.warning('密码修改成功，请重新登录');
          setTimeout(() => {
            singleLogout();
            if (process.env.NODE_ENV === 'development') { // 开发的话直接使用自带的一套登录
              dispatchNavigate('/');
            } else { // 跳转到kunlun去做登录
              window.location.href = `${process.env.KUNLUN_URL}?origin=${encodeURIComponent(window.location.href)}`;
            }
          }, 1000);
        });
      });
    },
    onCancel() {
      onClose();
      form.resetFields();
    }
  });

  return (
    <Modal
      title={'修改密码'}
      open={visible}
      onOk={methods.onOk}
      onCancel={methods.onCancel}
      destroyOnClose
      getContainer={false}
      maskClosable={false}
    >
      <Form {...layout} form={form} validateTrigger='onBlur'>
        <FormInputPassword
          label='旧密码'
          name='oldPassword'
          config={{
            autoComplete: 'new-password'
          }}
          rules={[{ required: true, message: '请输入旧密码' }]}
        />
        <FormInputPassword
          label='新密码'
          name='newPassword'
          rules={[{ required: true, message: '请输入新密码' }, pstRule]}
        />
        <FormInputPassword
          label='重复密码'
          name='rePassword'
          dependencies={['newPst']}
          rules={[
            { required: true, message: '请输入重复密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('必须与新密码一致'));
              },
            }),
          ]}
        />
      </Form>
    </Modal>
  );
};

export default ModifyPassword;
